import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Revert = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Revert" {...props}>
    <path d="M6.29002 3.29601C6.67886 2.90393 7.31192 2.90136 7.70408 3.29015C8.0961 3.67901 8.09871 4.31207 7.70994 4.70422L5.43357 7.00011H17C19.7614 7.00012 22 9.2387 22 12.0001V16.0001C21.9999 18.7615 19.7613 21.0001 17 21.0001H11C10.4478 21.0001 10.0001 20.5523 9.99998 20.0001C9.99998 19.4478 10.4477 19.0001 11 19.0001H17C18.6568 19.0001 19.9999 17.6569 20 16.0001V12.0001C20 10.3433 18.6568 9.00012 17 9.00011H5.39451L7.70408 11.2902C8.09609 11.679 8.09869 12.3121 7.70994 12.7042C7.32112 13.0962 6.68803 13.0988 6.29588 12.7101L2.29588 8.74523C2.10757 8.55856 2.00119 8.30432 1.99998 8.03918C1.99883 7.77405 2.10342 7.5195 2.29002 7.33117L6.29002 3.29601Z" fill="#000" />
  </StyledIcon>
));

Revert.displayName = 'Revert';

export { Revert };
